import { useEffect, useMemo, useState } from "react";
import { DataRequest, useCurseDataTableProps } from "./types";
export default function useCurseDataTable<T>({
  initialVariables,
  query,
  ApiSetData,
}: useCurseDataTableProps) {
  const searchParams = new URLSearchParams(window.location.search);
  const [variables, setVariables] = useState<any>(initialVariables);
  const [{ error, loading, data }, setData] = useState<DataRequest>({
    loading: true,
  });

  const handleChangePage = (page: number) => {
    setVariables((prev: any) => ({ ...prev, page }));
  };
  const [searchValue, setSearchValue] = useState("");
  const handleSearch = () => {
    setVariables((prev: any) => ({
      ...prev,
      page: searchValue !== prev.search ? 1 : prev.page,
      search: searchValue,
    }));
  };

  const handleChangeFilter = ({ status }: { status?: "ACTIVE" | "INACTIVE" | "DRAFT" | null }) => {
    setVariables((prev: any) => ({
      ...prev,
      page: status !== prev.status ? 1 : prev.page,
      status,
    }));
  };

  const handleChangeFilterCurses = () => {
    setVariables((prev: any) => ({
      ...prev,
      page: 1,
      filter: {
        educationalUnitNames: searchParams.getAll("educationalUnitNames")?.length
          ? searchParams.getAll("educationalUnitNames")
          : null,
        modalitiesNames: searchParams.getAll("modalitiesNames")?.length
          ? searchParams.getAll("modalitiesNames")
          : null,
        partnerVisibleNames: searchParams.getAll("partnerVisibleNames")?.length
          ? searchParams.getAll("partnerVisibleNames")
          : null,
        teachingAreaNames: searchParams.getAll("teachingAreaNames")?.length
          ? searchParams.getAll("teachingAreaNames")
          : null,
        states: searchParams.getAll("states")?.length ? searchParams.getAll("states") : null,
        categoriesSlugs: searchParams.getAll("categoriesSlugs")?.length
          ? searchParams.getAll("categoriesSlugs")
          : null,
      },
    }));
  };

  useMemo(() => {
    if (variables) {
      setData((old) => ({ ...old, loading: true }));
      setSearchValue(variables?.search || "");

      ApiSetData({
        query,
        variables,
        setData,
      });
    }
  }, [variables]);

  return {
    handleChangePage,
    handleChangeFilter,
    error,
    loading,
    data,
    handleSearch,
    searchValue,
    setSearchValue,
    variables,
    handleChangeFilterCurses,
  };
}
